import { useAuth } from "@/contexts/AuthContext";
import { useProgramYear } from "@/contexts/ProgramYearContext";
import { PaymentAdjustmentCard } from "./reports/PaymentAdjustmentCard";
import { PathwayReportCard } from "./reports/PathwayReportCard";
import { EligibilityChangesCard } from "./reports/EligibilityChangesCard";
import { InsightsGridSkeleton } from "./InsightsSkeleton";
import { RequestCustomReportCard } from "./RequestCustomReportCard";
import { useMipsCategoryScores } from "@/hooks/queries/useMipsQueries";

export function InsightsGrid() {
  const { selectedPractice } = useAuth();
  const { programYear } = useProgramYear();
  const practiceId = selectedPractice?.id;

  // Shared React Query pipeline (frontend-snappiness Phase 1a): weights +
  // scores + IA/Cost enrichments are one cache entry per practice/year across
  // the app — replaces this component's private 60s scoreCache and its
  // duplicate of the Gap Management composite math.
  const { compositeScore, loading } = useMipsCategoryScores(practiceId, programYear);

  // Skeleton only when we truly have nothing to show (cold cache). Revisits
  // and year switches render last-good data while revalidating.
  if (practiceId && loading) {
    return <InsightsGridSkeleton />;
  }

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
      <PaymentAdjustmentCard compositeScore={compositeScore} />
      <PathwayReportCard />
      <EligibilityChangesCard />
      <RequestCustomReportCard
        program="mips"
        entityType="practice"
        entityId={practiceId ?? null}
        entityLabel={selectedPractice?.practice_alias || selectedPractice?.tin_name || null}
        programYear={programYear}
      />

      {/* Future report cards will be added here */}
      {/* <QualityTrendsCard /> */}
      {/* <ProviderComparisonCard /> */}
      {/* <BenchmarkAnalysisCard /> */}
    </div>
  );
}
